import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children, roles }) => {
  const token = localStorage.getItem("token");
  const userRole = useSelector((state) => state.user.role);
  const location = useLocation();

  // Redirect to login if user is not authenticated, and store where they came from
  if (!token || !userRole) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Redirect to "not-authorized" if the role is not allowed
  if (roles && !roles.includes(userRole)) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
};

export default RequireAuth;
